<ng-container [ngSwitch]="metadata.layout?.type">

	<h1 *ngIf="depth==1 && metadata.label">{{metadata.label}}</h1>
	<div *ngIf="depth>1" class="h{{depth}} card-header">{{metadata.label}}</div>
	<div class="card mb-3" *ngIf="metadata.content.length">
		<div class="card-body">

			<!-- TABLE LAYOUT -->
			<ng-container *ngSwitchCase="'table'">
				<table class=" table-sm table-borderless">
					<tr>
						<th *ngFor="let th of tableHeaders">{{th}}</th>
					</tr>
					<ng-container *ngFor="let m of metadata.content">
						<ng-container *ngIf="m.type=='container' || (m.content && m.content.length)">
							<tr>
								<ng-container *ngFor="let m2 of m.content">
									<ng-container *ngIf="m2.type!='container'">
										<td>
											<ui-input [presentationMode]="presentationMode" [metadata]="m2" [(ngModel)]="data[m.id][m2.id]" [name]="depth+'_'+m2.id"></ui-input>
										</td>
									</ng-container>
								</ng-container>
							</tr>
						</ng-container>
					</ng-container>
				</table>
			</ng-container>


			<!-- DEFAULT LAYOUT -->
			<div *ngSwitchDefault>
				<ng-container *ngFor="let m of metadata.content">
					<ng-container *ngIf="m.type=='container' || (m.content && m.content.length)">

						<div class="form-group">
							<form-engine [presentationMode]="presentationMode" [metadata]="m" [data]="data[m.id]" [depth]="depth+1"></form-engine>
						</div>
					</ng-container>

					<ng-container *ngIf="m.type!='container'">
						<div class="form-group row">
							<div class="col-lg-{{m.layout?.labelWidth?m.layout?.labelWidth:2}}">
								<ui-label [label]="m.label" [hint]="m.hint"></ui-label>
							</div>
							<div class="col-lg-{{m.layout?.inputWidth?m.layout?.inputWidth:10}}">
								<ui-input
									[presentationMode]="presentationMode"
									[metadata]="m"
									[(ngModel)]="data[m.id]"
									[name]="depth+'_'+m.id"></ui-input>
							</div>
						</div>
					</ng-container>
				</ng-container>
				<ng-content></ng-content>
			</div>


			<!--<div style="background: #ccc">
				<button type="button" (click)="show= !show">toggle</button>
				<div *ngIf="show">
					<h1>Data</h1>
					<pre>{{data|json}}</pre>
					<h1>MetaData</h1>
					<pre>{{metadata|json}}</pre>
				</div>
			</div>-->
		</div>

	</div>
</ng-container>





